import { END_DATE_IS_REQUIRED, START_DATE_IS_REQUIRED } from "./messageConstants";
import { THREE_MONTHS_FROM, ONE_YEAR_IN_PAST } from "./dateHelper";

export function validateConflictReportStartDateFilter(input, endDateFilter, station) {
  if (input === null) {
    return START_DATE_IS_REQUIRED;
  }

  if (endDateFilter.toMillis() < input.toMillis()) {
    return "End Date cannot be prior to Start Date";
  }

  if (endDateFilter.toMillis() > THREE_MONTHS_FROM(station, input).toMillis()) {
    return "Start Date cannot be over 3 months before End Date";
  }

  return "";
}

export function validateConflictReportEndDateFilter(input, startDateFilter, station) {
  if (input === null) {
    return END_DATE_IS_REQUIRED;
  }

  if (input.toMillis() < startDateFilter.toMillis()) {
    return "End Date cannot be prior to Start Date";
  }

  if (input.toMillis() < ONE_YEAR_IN_PAST(station).toMillis()) {
    return "End Date cannot be prior to 1 year in the past";
  }

  if (input.toMillis() > THREE_MONTHS_FROM(station, startDateFilter).toMillis()) {
    return "End Date cannot be over 3 months after Start Date";
  }
  return "";
}
